import { IAderenciaChartProps } from '../..'
import ApexCharts from 'apexcharts'
import { useEffect } from 'react'
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/restrict-plus-operands */

export interface IResultadoProps{
  id?: string
  resultadoEntregue: IAderenciaChartProps
  resultadoComputado: IAderenciaChartProps
  onChoiceAderencia: (item: number, item2: number) => void

}

export const GraficoResultado: React.FC<IResultadoProps> = ({ id, resultadoComputado, resultadoEntregue, onChoiceAderencia }) => {
  function GerarGrafico(): void {
    const options = {
      series: [
        {
          name: 'Aderentes',
          data: [resultadoComputado.aderentes, resultadoEntregue.aderentes]
        },
        {
          name: 'Aderentes com ressalva',
          data: [resultadoComputado.aderentesRessalva, resultadoEntregue.aderentesRessalva]
        },
        {
          name: 'Não aderentes',
          data: [resultadoComputado.naoAderentes, resultadoEntregue.naoAderentes]
        }
      ],
      colors: ['#27AE60', '#FFBF2A', '#EB5757'],
      chart: {
        type: 'bar',
        stacked: true,
        height: 450,
        width: 360,
        events: {
          dataPointSelection: function(chartContext: any, seriesIndex: any, opts: any) {
            console.log(opts)
            onChoiceAderencia(opts.dataPointIndex, opts.seriesIndex)
          }
        }
      },
      plotOptions: {
        bar: {

          horizontal: false,
          dataLabels: {
            total: {
              enabled: true,
              offsetX: 0,
              style: {
                fontSize: '12px',
                fontWeight: 900
              }
            }
          }
        }
      },
      stroke: {
        width: 1,
        colors: ['#ccc']
      },
      title: {
        text: 'Resultado entregue X IA'
      },
      xaxis: {
        categories: ['Computado IA', 'Entregue']
      },
      yaxis: {
        title: {
          text: undefined
        }
      },
      tooltip: {
        y: {
          formatter: function (val: any) {
            return `${val} (${((val / resultadoEntregue.total) * 100).toFixed(1)}%)`
          }
        }
      },
      fill: {
        opacity: 1
      },
      legend: {
        position: 'bottom',
        horizontalAlign: 'center',
        offsetY: 10
      }
    }

    const chart = new ApexCharts(document.querySelector(`#${id ?? 'asdfafd334'}`), options)
    chart.render()
  }

  useEffect(() => {
    GerarGrafico()
  }, [resultadoComputado, resultadoEntregue])

  return (<div id={id ?? 'asdfafd334'}></div>)
}
